import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Box, Typography } from '@mui/material';
import FormGenerator from '@sharedCR/common/formGenerator';
import { FormNames } from 'app/services/autoLockForms/autoLockForms.constants';
import PropTypes from 'prop-types';

import { selectIsLoanNoPpeEngineType } from 'store/loanApplications/selectors';

import { getLoanProgramConfig } from './LoanProgramSection.config';
import {
  loanProgramSectionStyles,
  loanProgramTitleStyles,
  ppeIndicatorStyles,
} from './LoanProgramSection.styles';

const LoanProgramSection = ({
  form,
  changedFields,
  handleChange,
  indexTypesOptions,
  isIndexRequired,
  isLoading,
  isSaving,
  pendingChanges,
  disabledPendingChangesHighlight,
  setInForm,
  staticValidateField,
  validateField,
  validationErrors,
}) => {
  const isLoanNoPpeEngineType = useSelector(selectIsLoanNoPpeEngineType);

  const loanProgramConfig = useMemo(
    () => getLoanProgramConfig({ form, indexTypesOptions, isIndexRequired }),
    [form, indexTypesOptions, isIndexRequired],
  );

  return (
    <Box sx={loanProgramSectionStyles}>
      <Box sx={loanProgramTitleStyles}>
        <Typography variant="bold16">
          Loan Program
          {!isLoanNoPpeEngineType && (
            <Box component="span" sx={ppeIndicatorStyles}>
              PPE
            </Box>
          )}
        </Typography>
      </Box>
      <FormGenerator
        isNestedForm
        changedFields={changedFields}
        config={loanProgramConfig}
        disabledPendingChangesHighlight={disabledPendingChangesHighlight}
        form={form}
        formName={FormNames.LOAN_DETAILS}
        handleChange={handleChange}
        isLoading={isSaving || isLoading}
        numberOfColumns={4}
        pendingChanges={pendingChanges}
        setInForm={setInForm}
        staticValidateField={staticValidateField}
        validateField={validateField}
        validationErrors={validationErrors}
      />
    </Box>
  );
};

LoanProgramSection.propTypes = {
  handleChange: PropTypes.func.isRequired,
  indexTypesOptions: PropTypes.array.isRequired,
  isIndexRequired: PropTypes.bool.isRequired,
  pendingChanges: PropTypes.object.isRequired,
  disabledPendingChangesHighlight: PropTypes.bool.isRequired,
  setInForm: PropTypes.func.isRequired,
  staticValidateField: PropTypes.func.isRequired,
  validateField: PropTypes.func.isRequired,
  validationErrors: PropTypes.object.isRequired,
  form: PropTypes.object,
  changedFields: PropTypes.object,
  isLoading: PropTypes.bool,
  isSaving: PropTypes.bool,
};

export default memo(LoanProgramSection);
